// Ensure the backend URL has a protocol
const getBackendUrl = () => {
    const url = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

    // If URL doesn't start with http:// or https://, add https://
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        // console.warn('Backend URL missing protocol, adding https://');
        return `https://${url}`;
    }

    return url;
};

const API_BASE_URL = getBackendUrl();

// // Log the API URL for debugging
// console.log('API Base URL:', API_BASE_URL);

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

// Order related API calls
export const orderAPI = {
    // Create a new order
    createOrder: async (orderData) => {
        return await apiCall('/api/orders/create', {
            method: 'POST',
            body: JSON.stringify(orderData),
        });
    },

    // Verify payment
    verifyPayment: async (paymentData) => {
        return await apiCall('/api/orders/verify', {
            method: 'POST',
            body: JSON.stringify(paymentData),
        });
    },

    // Get booking details
    getBooking: async (bookingId) => {
        return await apiCall(`/api/orders/booking/${bookingId}`, {
            method: 'GET',
        });
    },
};

// Health check
export const checkHealth = async () => {
    return await apiCall('/health', {
        method: 'GET',
    });
}; 